import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {SizeList, SizeOptionProps} from '@aboutyou/ui-components';
import React, {FC, useCallback, useEffect} from 'react';
import {useNormalizedSizes} from './helpers';

interface InlineSizesProps {
  onShowSizeReminder: (size: SizeSelection_Size) => void;
  onSizeSelect: (size: SizeSelection_Size) => void;
  selectedSize: SizeSelection_Size | undefined;
  sizes: SizeSelection_Size[];
  shouldUseRemindMeBellIconButton?: boolean;
  enableYourSizeGreyBadges?: boolean;
}
export const InlineSizeSelection: FC<InlineSizesProps> = ({
  onShowSizeReminder,
  onSizeSelect,
  selectedSize,
  sizes,
  shouldUseRemindMeBellIconButton,
  enableYourSizeGreyBadges,
}) => {
  const {isActive: enablePriceOverhaulV2} = useIsFeatureActive(
    'ab_price_display_overhaul_v2',
  );
  const normalizedSizes: Array<SizeOptionProps> = useNormalizedSizes(sizes, {
    enableYourSizeGreyBadges,
    enablePriceOverhaulV2,
  });

  const attemptToSelectSize = useCallback(
    (selectedSize: SizeSelection_Size | undefined) => {
      if (selectedSize) {
        if (selectedSize.availability?.$case === 'soldOut') {
          onShowSizeReminder(selectedSize);
        } else {
          onSizeSelect(selectedSize);
        }
      }
    },
    [onShowSizeReminder, onSizeSelect],
  );

  const handleSizeSelect = useCallback(
    (sizeId: number) => {
      const selected = sizes.find(size => size.sizeId === sizeId);
      attemptToSelectSize(selected);
    },
    [attemptToSelectSize, sizes],
  );

  useEffect(() => {
    if (sizes.length === 1) {
      attemptToSelectSize(sizes[0]);
    }
  }, [sizes, attemptToSelectSize]);

  return (
    <SizeList
      sizes={normalizedSizes}
      onSizeSelect={handleSizeSelect}
      selectedSizeId={selectedSize?.sizeId}
      displayVariantPrices={normalizedSizes.length > 1}
      enableEndBadgeBellIcon={shouldUseRemindMeBellIconButton}
    />
  );
};
